// WhoWeAre.jsx — corrigé pour correspondre aux images fournies
// Remplace le contenu du fichier existant

import React from "react";
import PureHeader from "../../shared/FrontHeader/PureHeader";
import FrontFooter from "../../shared/FrontFooter/FrontFooter";
import FrontMainNav from "../../shared/FrontMainNav/FrontMainNav";
import QUI_SOMMES_NOUS_IMAGE from "..//..//..//assets/images/appImages/quijesuis.png";

// ─── CSS inline (à déplacer dans votre fichier CSS global) ───────────────────
const styles = `
  /* ===== QUI SOMMES-NOUS — reset & base ===== */
  .qsn-page {
    font-family: "Montserrat", sans-serif;
    color: #333;
    background: #fff;
  }

  /* ── Titre principal centré ── */
  .qsn-main-title {
    text-align: center;
    font-size: clamp(1.6rem, 3.5vw, 2.25rem);
    font-weight: 700;
    color: #222;
    margin: 0;
    padding: 2.5rem 1rem 2rem;
  }

  /* ── Section À propos ── */
  .qsn-about {
    max-width: 900px;
    margin: 0 auto;
    padding: 0 1.5rem 3rem;
  }

  /* ── Ligne 1 : image + texte d'intro ── */
  .qsn-top-row {
    display: flex;
    gap: 2.5rem;
    align-items: flex-start;
    margin-bottom: 2.5rem;
  }

  .qsn-image-wrapper {
    flex: 0 0 260px;
    max-width: 260px;
  }

  .qsn-image {
    width: 300px;
    height: 270px;
    backgroud-position: center;
    object-fit: cover;
    display: block;
    border-radius: 4px;
  
  }

  .qsn-text-col {
    flex: 1;
    min-width: 0;
  }

  .qsn-company-title {
    font-size: clamp(1.25rem, 2vw, 1.6rem);
    font-weight: 700;
    color: #111;
    text-transform: uppercase;
    margin: 0 0 1rem;
    line-height: 1.25;
  }

  .qsn-intro-text {
    font-size: 0.95rem;
    line-height: 1.90;
    color: #111;
    
  }

  /* ── Contenu pleine largeur ── */
  .qsn-full-content {
    margin-top: 0;
  }

  .qsn-section-title {
    font-size: 1rem;
    font-weight: 700;
    color: #111;
    margin: 0 0 0.75rem;
  }

  .qsn-text {
    font-size: 0.92rem;
    line-height: 1.75;
    color: #111;
    margin: 0 0 0.6rem;
  }

  /* ── Liste des pôles ── */
  .qsn-poles-list {
    list-style: none;
    padding: 0;
    margin: 0.5rem 0 0;
  }

  .qsn-poles-list > li {
    margin-bottom: 1.25rem;
    padding-left: 1.2rem;
    position: relative;
    // font-weight: 800;
  }

  .qsn-poles-list > li::before {
    content: "•";
    position: absolute;
    left: 0;
    top: 0.05em;
    color: #333;
    font-size: 1rem;
  }

  .qsn-pole-title {
    font-weight: 700;
    font-size: 0.95rem;
    color: #111;
    display: block;
    margin-bottom: 0.35rem;
  }

  .qsn-pole-desc {
    font-size: 0.92rem;
    line-height: 1.7;
    color: #333;
    margin: 0;
  }

  /* ── Sous-liste ferme ── */
  .qsn-ferme-list {
    list-style: disc;
    padding-left: 1.4rem;
    margin: 0.4rem 0 0;
  }

  .qsn-ferme-list li {
    font-size: 0.92rem;
    line-height: 1.7;
    color: #333;
    margin-bottom: 0.15rem;
  }

  /* ── Section Nos valeurs ── */
  .contentValeur{

    max-width: 900px;
    margin: 0 auto;
    padding: 0 1.5rem 3rem;
  }
    .qsn-valeurs-section {
      background-color:#0000000D;
    }

  .qsn-valeurs-separator {
    width: 80px;
    height: 3px;
    background: #935D34;
    margin-bottom: 1.5rem;
  }

  .qsn-valeurs-title {
    font-size: 1rem;
    font-weight: 700;
    color: #111;
    margin: 0 0 1rem;
  }

  .qsn-valeurs-text {
    font-size: 0.92rem;
    line-height: 1.75;
    color: #333;
    margin: 0 0 0.75rem;
  }

  .qsn-valeurs-text strong {
    font-weight: 700;
    color: #111;
  }

  /* ── Responsive ── */
  @media (max-width: 767px) {
    .qsn-top-row {
      flex-direction: column;
      justify-content:center;
      gap: 1.5rem;
    }

    .qsn-main-title {
      padding: 1.5rem 1rem 1.25rem;
    }

    .qsn-image-wrapper {
      margin: 0 auto;
      width: 100%;
    }

    .qsn-image {
      max-height: 210px;
      width: 100%;
    }
  }
`;

function WhoWeAre() {
  // Image placeholder (remplacez par votre import)

  return (
    <div className="landing-page-component qsn-page">
      {/* Inject styles */}
      <style>{styles}</style>

      <PureHeader />
      <FrontMainNav />

      <div className="page-content">

        {/* ── Titre principal ── */}
        <h1 className="qsn-main-title">Qui sommes-nous ?</h1>

        {/* ── Section À propos ── */}
        <div className="qsn-about">

          {/* Ligne 1 : image + intro */}
          <div className="qsn-top-row ">
            <div className="qsn-image-wrapper ">
              <img
                src={QUI_SOMMES_NOUS_IMAGE}
                alt="Pure Essence Botanicals"
                className="qsn-image"
              />
            </div>

            <div className="qsn-text-col">
              <h2 className="qsn-company-title">Pure Essence Botanicals</h2>
              <p className="qsn-intro-text mt-5">
                Chez PURE ESSENCE, nous sommes engagés dans une démarche globale
                qui relie la terre, la transformation et le bien-être au
                quotidien. Entreprise sénégalaise ancrée dans ses valeurs, nous
                développons une activité intégrée allant de la production
                agricole à la transformation de produits finis, avec une volonté
                forte : valoriser les ressources locales tout en proposant des
                solutions saines, efficaces et accessibles.
              </p>
            </div>
          </div>

          {/* Contenu pleine largeur */}
          <div className="qsn-full-content">
            <h3 className="qsn-section-title">
              Une chaîne complète, de la terre au produit fini
            </h3>

            <p className="qsn-text">
              Grâce à notre propre exploitation agricole, nous cultivons et
              sélectionnons une partie de nos matières premières. Cette
              proximité avec la terre nous permet de garantir la fraîcheur, la
              qualité et la traçabilité de nos produits.
            </p>
            <p className="qsn-text">
              Nous avons structuré notre activité autour de quatre grands pôles :
            </p>

            <ul className="qsn-poles-list">
              <li>
                <span className="qsn-pole-title">Transformation agroalimentaire</span>
                <p className="qsn-pole-desc">
                  Nous transformons des fruits et légumes locaux en produits
                  déshydratés afin de préserver leurs nutriments, prolonger leur
                  conservation et réduire le gaspillage alimentaire. Cette
                  activité met en valeur les récoltes locales et offre une
                  alternative saine et naturelle pour la consommation
                  quotidienne.
                </p>
              </li>

              <li>
                <span className="qsn-pole-title">Cosmétique naturelle</span>
                <p className="qsn-pole-desc">
                  Nous formulons des soins capillaires et corporels à base
                  d'ingrédients issus de la richesse africaine : huiles
                  végétales, beurres naturels, plantes et extraits locaux. Nos
                  produits sont pensés pour respecter la peau et les cheveux,
                  tout en valorisant des formulations inspirées de la nature.
                </p>
              </li>

              <li>
                <span className="qsn-pole-title">Produits d'entretien non nocifs</span>
                <p className="qsn-pole-desc">
                  Nous développons également une gamme de produits ménagers
                  efficaces et respectueux de la santé et de l'environnement.
                  Nos détergents, lessives et nettoyants sont conçus pour
                  réduire l'exposition aux substances agressives tout en
                  garantissant une propreté irréprochable.
                </p>
              </li>

              <li>
                <span className="qsn-pole-title">Notre ferme</span>
                <p className="qsn-pole-desc">
                  Nous proposons enfin une gamme de produits issus directement
                  de notre exploitation :
                </p>
                <ul className="qsn-ferme-list">
                  <li className="fw-bold">Fruits et légumes frais de saison</li>
                  <li className="fw-bold">Œufs frais</li>
                  <li className="fw-bold">Poulets et Poissons frais</li>
                </ul>
              </li>
            </ul>
          </div>
        </div>

        {/* ── Section Nos valeurs ── */}
        <div className="qsn-valeurs-section">
          <div className="contentValeur py-5">
            <p className="qsn-valeurs-text">Cette activité nous permet de rester proches de la production primaire et de proposer des aliments de qualité, accessibles et locaux.</p>
          <div className="qsn-valeurs-separator" />

          <h3 className="qsn-valeurs-title">Nos valeurs</h3>

          <p className="qsn-valeurs-text">
            À travers <strong>PURE ESSENCE</strong>, nous voulons créer un
            modèle où l'agriculture, la transformation et la consommation locale
            sont étroitement liées.
          </p>

          <p className="qsn-valeurs-text">
            Nous croyons en une économie qui valorise les ressources africaines,
            limite les pertes alimentaires et propose des produits plus sains
            pour les familles et les professionnels. Nous croyons en une
            économie où chaque ressource a de la valeur, où rien ne se perd, et
            où tout peut être transformé avec sens.
          </p>

          <p className="qsn-valeurs-text">
            <strong>PURE ESSENCE</strong>, c'est une vision simple :<br />
            <strong>DU PRODUCTEUR AU CONSOMMATEUR</strong> : produire mieux,
            transformer localement, durablement, consommer sainement et
            directement.
          </p>
          </div>
        </div>
      </div>

      <FrontFooter />
    </div>
  );
}

export default WhoWeAre;